export const giveRiskAppreciationWarnings = ($form) => {
  $('.risk-appreciation-question').each((index, _question) => {
    $(`#risk_appreciation_${index + 1} input[type=radio]`, $form).on('change', (e) => {
      if (e.target.value === 'false') {
        $(`#warning_risk_appreciation_${index + 1}`, $form).removeClass('d-none');
      } else {
        $(`#warning_risk_appreciation_${index + 1}`, $form).addClass('d-none');
      }
    });
  });
}
